import axios from 'axios';

const client = () =>
{
    const defaultOptions = { withCredentials: true };
    return {
        get: (url, options = {}) => axios.get(url, { ...defaultOptions, ...options }),
        post(url, params, options = {}, header = null)
        {
            let formData = false;
            for (const key in params)
            {
                if (Object.prototype.toString.call(params[key]) === '[object File]')
                {
                    formData = true;
                }
            }

            if (header != null)
            {
                const optionsSec = {
                    ...defaultOptions,
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                };

                const data = new FormData();
                for (const key in params)
                {
                    if (Object.prototype.toString.call(params[key]) === '[object File]')
                    {
                        data.append(key, params[key], params[key].name);
                    }
                    else if (Object.prototype.toString.call(params[key]) === '[object Array]')
                    {
                        for (let i = 0; i < params[key].length; i += 1) {
                            data.append(`${key}_${i}`, JSON.stringify(params[key][i]));
                        }
                    }
                    else
                    {
                        data.append(key, params[key]);
                    }
                }
                return axios.post(url, data, { ...optionsSec, ...options });
            }

            if (formData)
            {
                const optionsSec = {
                    ...defaultOptions,
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                };

                const data = new FormData();
                for (const key in params)
                {
                    if (Object.prototype.toString.call(params[key]) === '[object File]')
                    {
                        data.append(key, params[key], params[key].name);
                    }
                    else
                    {
                        data.append(key, params[key]);
                    }
                }
                return axios.post(url, data, { ...optionsSec, ...options });
            }

            return axios.post(url, params, { ...defaultOptions, ...options });
        },
        put: (url, data, options = {}) => axios.put(url, data, { ...defaultOptions, ...options }),
        delete: (url, options = {}) => axios.delete(url, { ...defaultOptions, ...options }),
        errorHandler: (e) => e.toString(),
    };
};

export default client();
